// Characters that XML 1.0 forbids in element content and attributes.
//
// Unlike `<` or `&`, these cannot be escaped — a numeric reference such as
// `&#1;` is illegal too — so the only way to emit well-formed XML is to replace
// them. A single stray one makes a .docx unopenable: Word aborts the parse and
// reports the generic "Word experienced an error trying to open the file."
//
// They reach us from text extraction: a PDF glyph with no ToUnicode mapping
// falls through as its raw glyph index, so a minus sign can arrive as \x01.
//
// The surrogate-pair alternative must come FIRST. It matches well-formed pairs
// so the replacer can hand them straight back, which stops the lone-surrogate
// branch from tearing an emoji (or any astral-plane character) in half.
const INVALID_XML_CHARS =
  /[\uD800-\uDBFF][\uDC00-\uDFFF]|[\x00-\x08\x0B\x0C\x0E-\x1F\uD800-\uDFFF\uFFFE\uFFFF]/g;

// Vertical tab and form feed are break characters rather than junk, so they
// become a newline instead of vanishing and joining the words either side.
const BREAK_CHARS = '\v\f';

// NUL and the two noncharacters are encoding debris rather than lost text — a
// UTF-16 file read as UTF-8 is mostly NUL — so they are dropped outright.
const DISCARDED = '\x00\uFFFE\uFFFF';

// Everything else in the set stood in for a character we cannot recover, and
// dropping one silently changes what a quote says: an extracted "b = \x01.32"
// would export as "b = .32", losing the sign. U+FFFD leaves the loss visible in
// the document so a researcher can see it and correct it.
const REPLACEMENT_CHARACTER = '\uFFFD';

export const xmlSafeText = (text) => {
  if (text === null || text === undefined) return text;

  return String(text).replace(INVALID_XML_CHARS, (match) => {
    if (match.length === 2) return match; // a valid surrogate pair — keep it
    if (BREAK_CHARS.includes(match)) return '\n';
    if (DISCARDED.includes(match)) return '';
    return REPLACEMENT_CHARACTER;
  });
};
